// resources/js/app.js（Laravel 12 / Vite）

import './bootstrap'
import { createInertiaApp, router } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createApp, h } from 'vue'
import { ZiggyVue } from 'ziggy-js'
import { createPinia } from 'pinia'

const appName = import.meta.env.VITE_APP_NAME || 'Laravel'

// /admin 判定
const isAdminPath = (urlPath) => urlPath.startsWith('/admin')

// ===== フロント用アセット（CoreUI 以外）を必要時だけロード =====
let frontAssetsLoaded = false
async function loadFrontAssets () {
  if (frontAssetsLoaded) return
  frontAssetsLoaded = true

  await Promise.all([
    import('../css/normalize.css'),
    import('../css/base.css'),
    import('../css/page.css'),
    import('../css/swiper.min.css'),
    import('../css/style.css'),
  ])

  await import('./Utils/smooth-scroll')

  // jQuery
  const { default: $ } = await import('jquery')
  window.$ = window.jQuery = $

  // Swiper
  const { default: Swiper } = await import('swiper/bundle')
  await import('swiper/css/bundle')
  window.Swiper = Swiper

  // flatpickr + 日本語化
  const { default: flatpickr } = await import('flatpickr')
  await import('flatpickr/dist/flatpickr.css')
  const { Japanese } = await import('flatpickr/dist/l10n/ja.js')
  flatpickr.localize(Japanese)
}

// ===== CoreUI は /admin のときだけ動的に登録 =====
let coreuiLoaded = false
async function loadCoreUI (app) {
  if (coreuiLoaded) return
  const m = await import('./Plugins/coreui.js') // ← CoreUI プラグイン（CSS import もここに集約する）
  app.use(m.default)
  coreuiLoaded = true
}

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue')
    ),

  async setup ({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue)
      .use(createPinia())

    // 初回パスでどちらの束を読むか決める
    const firstPath = window.location.pathname
    if (isAdminPath(firstPath)) {
      await loadCoreUI(app)
    } else {
      await loadFrontAssets()
    }

    // 途中のページ遷移
    router.on('navigate', async (e) => {
      const url = new URL(e.detail.page.url, window.location.origin)
      const goingAdmin = isAdminPath(url.pathname)

      if (goingAdmin) {
        if (!coreuiLoaded) {
          // 既にマウント後に新規プラグインは差し込みにくいので、admin バンドルへ切替のためフルリロード
          window.location.href = url.href
          return
        }
      } else {
        // 非 admin へ出た後に一度だけフロント資産をロード（未ロードなら）
        if (!frontAssetsLoaded) {
          await loadFrontAssets()
        }
      }
    })

    app.mount(el)
    window.__app__ = app
  },

  progress: { color: '#4B5563' },
})
